import { render, staticRenderFns } from "./AboutApplicant.vue?vue&type=template&id=048213ae&scoped=true"
import script from "./AboutApplicant.vue?vue&type=script&lang=ts"
export * from "./AboutApplicant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048213ae",
  null
  
)

export default component.exports